export const validators = {
	data() {
		return {
			validators: {
				comment: {
					required: true,
				},
				start: {
					required: true
				},
				finish: {
					required: true
				},
				status: {
					required: true,
				},
				name: {
					required: true,
				},
				discount: {
					required: true,
				},
				deps: {
					required: true,
				},
				type: {
					required: true,
				}
			}
		}
	},

	methods: {
		checkField(name) {
			const valid = Object.keys(this.validationFields).some(() => this.validationFields[name].valid);
			const invalid = Object.keys(this.validationFields).some(() => this.validationFields[name].invalid);
			const touched = Object.keys(this.validationFields).some(() => this.validationFields[name].touched);
			const changed = Object.keys(this.validationFields).some(() => this.validationFields[name].changed);
			if (( touched) && valid) {
				return true;
			}
			if ((touched) && !valid) {
				return false
			}
			if ((changed) && invalid) {
				return false
			}

			return null
		}
	}
};
